import {
  SET_SORT,
  SET_SELECTED_FILTERS,
  CLEAR_BROWSE_PRODUCTS,
  UPDATE_SEARCH,
} from './actions';

const INITIAL_STATE = {
  error: null,
  isBrowsePage: false,
  searchTerm: '',
  selectedFilters: {},
  selectedSorts: {},
};

export function browse(
  state = INITIAL_STATE,
  { type, payload = {} }: any = {},
) {
  switch (type) {
    case SET_SELECTED_FILTERS:
      return { ...state, ...payload };
    case SET_SORT:
      return {
        ...state,
        selectedSorts: payload.value,
      };
    case CLEAR_BROWSE_PRODUCTS:
      return {
        ...state,
      };
    case UPDATE_SEARCH:
      return { ...state, searchTerm: payload.searchTerm };
    default:
      return state;
  }
}
